import HObject from '@/core/HObject.js'
import * as BABYLON from 'babylonjs'
import { cargarMaterial } from '@/core/materials.js'
import { Pantalla } from '@/core/Pantalla.js'
import { pantallas } from '@/core/utils.js'

export default class OfficeR06SY extends HObject {
  constructor (hObject) {
    super(hObject.name, hObject.type, hObject.allowRegistration)
    this.init(hObject)
    this.carpeta = this.name
    this.idPantalla = 0
  }

  register () {
    let hObject = this
    this.registered = true

    BABYLON.SceneLoader.ImportMesh('', 'static/assets/OfficeR06SY/', 'OF_R06_X.babylon', window.scene, function (newMeshes, particleSystems) {
      // var i, j
      var nColor = 1
      var nExterior = 1
      var nInterior = 1
      var nFicha = 1
      // var pantallaRexton = null

      hObject.objectConfigurations(newMeshes)
      hObject.lod(newMeshes, 50)

      newMeshes[3].material = cargarMaterial('banner', 'static/textures/sy/label-colores.jpg')
      newMeshes[43].material = cargarMaterial('banner', 'static/textures/sy/label-exterior.jpg')
      newMeshes[42].material = cargarMaterial('banner', 'static/textures/sy/label-interior.jpg')
      newMeshes[30].material = cargarMaterial('banner', 'static/textures/sy/label-ficha.jpg')

      newMeshes[33].material = cargarMaterial('banner', 'static/textures/sy/' + hObject.carpeta + '/banner.jpg')
      newMeshes[4].material = cargarMaterial('banner', 'static/textures/sy/' + hObject.carpeta + '/color1.jpg')
      newMeshes[4].material = cargarMaterial('banner', 'static/textures/sy/' + hObject.carpeta + '/color2.jpg')
      newMeshes[4].material = cargarMaterial('banner', 'static/textures/sy/' + hObject.carpeta + '/color3.jpg')
      newMeshes[4].material = cargarMaterial('banner', 'static/textures/sy/' + hObject.carpeta + '/color4.jpg')
      newMeshes[4].material = cargarMaterial('banner', 'static/textures/sy/' + hObject.carpeta + '/color5.jpg')

      if (hObject.carpeta !== 'rexton') {
        newMeshes[45].material = cargarMaterial('banner', 'static/textures/sy/' + hObject.carpeta + '/exterior1.jpg')
        newMeshes[45].material = cargarMaterial('banner', 'static/textures/sy/' + hObject.carpeta + '/exterior2.jpg')
        newMeshes[45].material = cargarMaterial('banner', 'static/textures/sy/' + hObject.carpeta + '/exterior3.jpg')
      }
      newMeshes[44].material = cargarMaterial('banner', 'static/textures/sy/' + hObject.carpeta + '/interior1.jpg')
      newMeshes[44].material = cargarMaterial('banner', 'static/textures/sy/' + hObject.carpeta + '/interior2.jpg')
      newMeshes[44].material = cargarMaterial('banner', 'static/textures/sy/' + hObject.carpeta + '/interior3.jpg')
      newMeshes[29].material = cargarMaterial('banner', 'static/textures/sy/ficha1.png')
      newMeshes[29].material = cargarMaterial('banner', 'static/textures/sy/ficha2.png')
      newMeshes[29].material = cargarMaterial('banner', 'static/textures/sy/ficha3.png')
      if (hObject.carpeta === 'rexton') {
        pantallas[pantallas.length] = new Pantalla(newMeshes[45], 'static/textures/sy/rexton/videoplayback.mp4', 10, false, true, true)
        hObject.idPantalla = pantallas.length
        // pantallaRexton = pantallas[pantallas.length]
      }

      newMeshes[7].dispose()
      // Colores
      newMeshes[1].actionManager = new BABYLON.ActionManager(window.scene)
      newMeshes[1].actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
        // console.log('mesh ' + carpeta + '....' + newMeshes[4].name)
        nColor++
        if (nColor > 5) {
          nColor = 1
        }
        newMeshes[4].material = cargarMaterial('banner', 'static/textures/sy/' + hObject.carpeta + '/color' + nColor + '.jpg')
      }))
      newMeshes[2].actionManager = new BABYLON.ActionManager(window.scene)
      newMeshes[2].actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
        // console.log('mesh ' + carpeta + '....' + newMeshes[4].name)
        nColor--
        if (nColor < 1) {
          nColor = 5
        }
        newMeshes[4].material = cargarMaterial('banner', 'static/textures/sy/' + hObject.carpeta + '/color' + nColor + '.jpg')
      }))
      // Exterior
      newMeshes[38].actionManager = new BABYLON.ActionManager(window.scene)
      newMeshes[38].actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
        if (hObject.carpeta !== 'rexton') {
          // console.log('mesh ' + carpeta + '....' + newMeshes[4].name)
          nExterior++
          if (nExterior > 3) {
            nExterior = 1
          }
          newMeshes[45].material = cargarMaterial('banner', 'static/textures/sy/' + hObject.carpeta + '/exterior' + nExterior + '.jpg')
        } else {
          // pantallas[0].reproducirVideo()
        }
      }))
      newMeshes[39].actionManager = new BABYLON.ActionManager(window.scene)
      newMeshes[39].actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
        if (hObject.carpeta !== 'rexton') {
          // console.log('mesh ' + carpeta + '....' + newMeshes[4].name)
          nExterior--
          if (nExterior < 1) {
            nExterior = 3
          }
          newMeshes[45].material = cargarMaterial('banner', 'static/textures/sy/' + hObject.carpeta + '/exterior' + nExterior + '.jpg')
        } else {
          // pantallas[0].pausarVideo()
        }
      }))
      // Interior
      newMeshes[37].actionManager = new BABYLON.ActionManager(window.scene)
      newMeshes[37].actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
        // console.log('mesh ' + carpeta + '....' + newMeshes[4].name)
        nInterior++
        if (nInterior > 3) {
          nInterior = 1
        }
        newMeshes[44].material = cargarMaterial('banner', 'static/textures/sy/' + hObject.carpeta + '/interior' + nInterior + '.jpg')
      }))
      newMeshes[35].actionManager = new BABYLON.ActionManager(window.scene)
      newMeshes[35].actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
        // console.log('mesh ' + carpeta + '....' + newMeshes[4].name)
        nInterior--
        if (nInterior < 1) {
          nInterior = 3
        }
        newMeshes[44].material = cargarMaterial('banner', 'static/textures/sy/' + hObject.carpeta + '/interior' + nInterior + '.jpg')
      }))
      // Ficha
      newMeshes[32].actionManager = new BABYLON.ActionManager(window.scene)
      newMeshes[32].actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
        // console.log('mesh ' + carpeta + '....' + newMeshes[4].name)
        nFicha++
        if (nFicha > 3) {
          nFicha = 1
        }
        newMeshes[29].material = cargarMaterial('banner', 'static/textures/sy/ficha' + nFicha + '.png')
      }))
      newMeshes[31].actionManager = new BABYLON.ActionManager(window.scene)
      newMeshes[31].actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
        // console.log('mesh ' + carpeta + '....' + newMeshes[4].name)
        nFicha--
        if (nFicha < 1) {
          nFicha = 3
        }
        newMeshes[29].material = cargarMaterial('banner', 'static/textures/sy/ficha' + nFicha + '.png')
      }))
    })
  }

  door (instruction) {
    console.log('Instruction ' + instruction)
  }
}



// WEBPACK FOOTER //
// ./src/hobjects/OfficeR06SY.js